module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp12_8003.b727e115.png";